$(document).scroll(function(){
    $( ".weeklydroplets-droplets.__cover" ).each(function() {
        var el = $(this);
        var screenHeight = $(window).height()
        var top = $(el).offset().top - $(document).scrollTop();
        if ((top - screenHeight) < 0){
            $(el).addClass('__filled');
        } else {
            $(el).removeClass('__filled');
        }
    });
    $( ".mixcontent-wales" ).each(function() {
        var el = $(this);
        var screenHeight = $(window).height()
        var top = $(el).offset().top - $(document).scrollTop();
        if ((top - screenHeight) < 0){
            $(el).addClass('__filled');
        } else {
            $(el).removeClass('__filled');
        }
    });
});